import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useCountriesQuery } from 'api/generated/graphql';
import { parseCountryRiskLevel, useError } from 'api/helpers';
import { CountryRiskLevelType } from 'api/types/entity';
import { lodash } from 'helpers';

/**
 * Risk levels by country id, current or as of the moment `at`. A country missing
 * from the map is not found in the directory, an `undefined` value means the level is not set.
 */
export const useCountryRiskLevels = (at?: Date) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useCountriesQuery({
    variables: at ? { at: at.toISOString() } : undefined,
    // Levels as of a moment must not replace the current ones in the normalized cache
    fetchPolicy: at ? 'no-cache' : 'cache-first',
  });

  const error = useError(apolloError);

  const countryRiskLevels = useMemo(
    () =>
      data?.countries
        ? new Map<string, CountryRiskLevelType | undefined>(
            lodash
              .compact(data.countries)
              .map((country) => [
                country.id,
                country.riskLevel
                  ? parseCountryRiskLevel(country.riskLevel)
                  : undefined,
              ])
          )
        : undefined,
    [data?.countries]
  );

  return {
    countryRiskLevels,
    loading,
    error,
  };
};
